export const addStaticSubdomain = (url?: string) => {
  const sourceDomain = "https://amityonline.com";
  const staticDomain = "https://static.amityonline.com";

  if (url?.startsWith(sourceDomain)) {
    return url?.replace(sourceDomain, staticDomain);
  }

  return url;
}

/** Absolute CMS/CDN URL the download API can fetch. */
export function resolveBrochureUrl(basicDetails?: {
  Brochure?: unknown;
}): string {
  const brochure = basicDetails?.Brochure;
  let raw = "";

  if (typeof brochure === "string") {
    raw = brochure;
  } else if (brochure && typeof brochure === "object") {
    const media = brochure as {
      url?: string;
      data?: { attributes?: { url?: string } };
    };
    raw = media.data?.attributes?.url || media.url || "";
  }

  if (!raw) return "";

  if (/^https?:\/\//i.test(raw)) {
    return addStaticSubdomain(raw) || raw;
  }

  const path = raw.startsWith("/") ? raw : `/${raw}`;
  const absolute = `https://amityonline.com${path}`;
  return addStaticSubdomain(absolute) || absolute;
}